import { Description } from '@mui/icons-material';

import { FilePreviewBox } from './FilePreviewBox';

export interface CsvPreviewBoxProps {
  size?: number;
  iconSize?: number;
  onClick?: () => void;
}

export const CsvPreviewBox = (props: CsvPreviewBoxProps) => (
  <FilePreviewBox
    icon={Description}
    iconColor="success.main"
    label="CSV"
    {...props}
  />
);
